import { IRecentChargesData } from "../api/types";
import $api from "../http";
import { IInvoiceForTable } from "../models/Invoice";
import { TRecentCharge } from "../models/RecentCharge";

class InvoiceServiceClass {
  getInvoices(currentPage: number | undefined, pageSize: number | undefined) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    return $api.get<{ data: IInvoiceForTable[]; totalCount: number }>(
      `api/invoice/for-user?${queryString}`
    );
  }

  getRecentCharges(data: IRecentChargesData) {
    return $api.get<{ data: TRecentCharge[] }>(
      `api/users/recent-charges?fromDate=${data.fromDate}&toDate=${data.toDate}`
    );
  }
}

export const InvoiceService = new InvoiceServiceClass();
